import React from "react";
import { Tag } from "antd";
import { useTranslation } from "react-i18next";

interface CategoryLevelsProps {
  levels: string[];
}

const levelColor = (level: number) =>
  level === 1 ? "purple" : level === 2 ? "blue" : "default";

const CategoryLevels: React.FC<CategoryLevelsProps> = ({ levels }) => {
  const { t } = useTranslation();

  return (
    <span>
      {levels.map((name, index) => (
        <React.Fragment key={index}>
          {index > 0 && " / "}
          <span style={{ display: "inline-block" }}>
            <Tag
              color={levelColor(index + 1)}
              title={`${t("Common-Level")} ${index + 1}`}
              style={{ marginRight: 4, fontSize: 10 }}
            >
              N{index + 1}
            </Tag>
            {name}
          </span>
        </React.Fragment>
      ))}
    </span>
  );
};

export default CategoryLevels;
